import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import axios from 'axios';

import { Row, Col, Button, Card, CardHeader, CardFooter, CardBody, Form, FormGroup, Label, Input, Table, Alert } from 'reactstrap';

import * as vars from '../../constants/variables';

import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getGameTypes, getCategories } from "../../actions/CategoryActions";

import { console_log, jsUcfirst, formatDate } from "../../utils/helper";
import { config } from '../../constants/domainConfig';
const arabicDomain = (config.lang == 'ar') ? true : false;

var data = new FormData();

class ManageCategories extends Component {
    constructor(props) {
        super(props);
        this.state = {
            categoryName: '',
            categoryImage: false,
            categoryType: 0,
            isValid: false,
            errorMessage: ''
        };

        this.isValid = this.isValid.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    componentWillMount() {
        this.getGameTypes();
        this.getCategories();
    }

    componentDidUpdate() {
        if (!this.props.user.isAuthenticated) {
            this.props.history.push('/login');
        }
    }

    onSubmit(e) {
        e.preventDefault();

        if(this.isValid()){
            this.setState({ isValid: true, errorMessage: ''});
            this.addCategory({
                categoryName: this.state.categoryName,
                categoryImage: this.state.categoryImage,
                categoryTypeId: this.state.categoryType
            });
        }
    }

    isValid() {
        if (this.state.categoryName == '') {
            this.setState({
                isValid: false,
                errorMessage: "Category Name field is required."
            });
            return false;
        }
        if (!this.state.categoryImage) {
            this.setState({
                isValid: false,
                errorMessage: "Please select the category image file."
            });
            return false;
        }
        if (this.state.categoryType == 0) {
            this.setState({
                isValid: false,
                errorMessage: "Please select the category type."
            });
            return false;
        }

        return true;
    }

    onChange(e) {
        switch (e.target.name) {
            case 'categoryImage': {
                data.append('categoryImage', e.target.files[0]);
                this.setState({
                    categoryImage: (typeof e.target.files[0] == 'object') ? true : false
                });
                break;
            }
            default: {
                this.setState({
                    [e.target.name]: e.target.value
                });
            }
        }
    }

    addCategory(cat) {
        data.append('categoryName', cat.categoryName);
        data.append('categoryTypeId', cat.categoryTypeId);

        this.props.show();
        axios.post(vars.BASE_URL+'/addCategory', data)
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getCategories();
                }
                this.setState({
                    categoryName: '',
                    categoryType: 0,
                    categoryImage: false,
                    isValid: false,
                    errorMessage: ''
                })
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Sorry, cannot add category right now, please try again later.'});
            });
    }

    getGameTypes() {
        axios.get(vars.BASE_URL+'/getCategoryTypes')
            .then((response) => {
                if (response.data.success) {
                    this.props.getGameTypes(response.data);
                }
            })
            .catch((error) => {
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }
    getCategories() {
        this.props.show();
        axios.get(vars.BASE_URL+'/getCategories')
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    let dataFinal = response.data;
                    let categoriesArr = dataFinal.data;
                    dataFinal = { ...dataFinal, data: categoriesArr };
                    if(!(config.subDomain === 'cz' && isGamiclub)){
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'E-knihy'
                        })
                    }
                    if(config.subDomain === 'fr' && isGamiclub) {
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Heróis Verdes'
                        })
                    }
                    if(config.subDomain === 'my' && window.location.hostname.includes('gamiclub')) {
                        dataFinal.data = dataFinal.data.filter(category => {
                            let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos", "Political & Activism"]
                            return excludes.indexOf(category.categoryName) == -1
                        })
                    }
                    if(config.subDomain === 'es2' && window.location.hostname.includes('beemobi')) {
                        dataFinal.data = dataFinal.data.filter(category => {
                            let excludes = ["E-Learning", "Heróis Verdes", "Meu Emprego dos Sonhos"]
                            return excludes.indexOf(category.categoryName) == -1
                        })
                    }
                    else {
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Videos Virales'
                        })
                    }
                    if(config.subDomain !== 'rs'){
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Е-књиге'
                        })
                    }
                    if(config.subDomain !== 'tr' && config.subDomain !== 'qa' && config.subDomain !== 'kw'){
                        dataFinal.data = dataFinal.data.filter(category => {
                            return category.categoryName != 'Facebook'
                        })
                    }
                    this.props.getCategories(dataFinal);
                    
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }

    onDelete(categoryId) {
        this.props.show();
        axios.delete(vars.BASE_URL+'/deleteCategories', {
            data: {
                categoryIds: [
                    categoryId
                ]
            }
        })
            .then((response) => {
                this.props.hide();
                if (response.data.success) {
                    this.getCategories();
                }
            })
            .catch((error) => {
                this.props.hide();
                console_log(error);
                this.setState({ isValid: false, errorMessage: 'Unable to fetch the data.'});
            });
    }

    render() {
        return (
            <div className="manage-categories animated fadeIn">
                <Row>
                    <Col xs="12" md="12">
                        <Card>
                            <CardHeader>
                                <strong>Add Category</strong>
                            </CardHeader>
                            <CardBody>
                                <Form action="" method="post" encType="multipart/form-data" className="form-horizontal">
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="categoryName">Category Name</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="text" id="categoryName" name="categoryName" placeholder="Category Name" value={this.state.categoryName} onChange={this.onChange}/>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="categoryImage">Category Image</Label>
                                        </Col>
                                        <Col xs="12" md="9">
                                            <Input type="file" id="categoryImage" name="categoryImage" placeholder="Category Image" onChange={this.onChange} />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Col md="3">
                                            <Label htmlFor="categoryType">Games Type</Label>
                                        </Col>
                                        <Col xs="12" md="9" size="lg">
                                            <Input type="select" name="categoryType" id="categoryType" value={this.state.categoryType} onChange={this.onChange}>
                                                <option key={0} value="0">Type</option>
                                                {(this.props.categories.gameType.length > 0) ?
                                                    this.props.categories.gameType.map((type) => {
                                                        return (
                                                            <option key={type.categoryTypeId} value={type.categoryTypeId}>{type.categoryTypeName}</option>
                                                        )
                                                    })
                                                    : ''
                                                }
                                            </Input>
                                        </Col>
                                    </FormGroup>
                                    {(!this.state.isValid && this.state.errorMessage != '') ?
                                        <Alert color="danger">{this.state.errorMessage}</Alert> : ''}
                                </Form>
                            </CardBody>
                            <CardFooter className="card-footer-align-right">
                                <Button type="submit" color="primary" onClick={this.onSubmit}><i className="fa fa-check"></i> Add</Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <Table hover responsive size="lg" className="category-custom-table">
                                    <thead>
                                        <tr>
                                            <th>
                                                <input type="checkbox" size="lg" id="select-all" name="select-all" value="select-all" className="form-control-lg"/>
                                            </th>
                                            <th>Category Name</th>
                                            <th>Total Content</th>
                                            <th>Category Type</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(this.props.categories.categories.length > 0) ?
                                            this.props.categories.categories.map((data, i) => {
                                                return (
                                                    <tr key={i}>
                                                        <td>
                                                            <input type="checkbox" id={'category-'+data.categoryId} name={'category-'+data.categoryId} value={'category-'+data.categoryId} className="form-control-lg"/>
                                                        </td>
                                                        <td><strong>{ data.categoryName || '' }</strong></td>
                                                        <td>{ data.count || 0 }</td>
                                                        <td>{ data.categoryTypeName || '' }</td>
                                                        <td>
                                                            <Button size="sm" color="success">
                                                                <i className="fa fa-edit"></i>
                                                            </Button>
                                                            <Button size="sm" color="danger" onClick={this.onDelete.bind(this, data.categoryId)}>
                                                                <i className="fa fa-trash"></i>
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                )
                                            })
                                            : <tr>
                                                <td colSpan={5}>
                                                    No categories found.
                                                </td>
                                            </tr>
                                        }
                                    </tbody>
                                </Table>
                            </CardBody>
                            <CardFooter className="card-footer-align-right">
                                <Button color="danger">
                                    <i className="fa fa-trash"></i> Delete All
                                </Button>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.AuthenticationReducer,
        access: state.WelcomeReducer,
        domains: state.DomainReducer,
        country: state.CountryReducer,
        users: state.UsersReducer,
        categories: state.CategoryReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        getGameTypes,
        getCategories
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageCategories);


// WEBPACK FOOTER //
// ./src/components/Category/ManageCategories.js